module.exports = __webpack_public_path__ + "45854c457a1d150934b5fdfed36ee455.svg";